"use strict";

export function initInScope ($scope) {
    $scope.find('[data-toggle="tooltip"]').tooltip();
}
